import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

/**
 * 抄送api
 */
export class ApplyTravelSummaryBccApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'apply-travel-summary-bcc'
  }

}
